module.exports = __webpack_public_path__ + "img/wiggle01.f82be8c0.jpg";